import { container } from '@k-mille/ui-components'
import Component from './actions'

const mapStore = (store, { id }) => store.data.invoices.get(id)

export default container({
  mapStore,
})(Component)
